import { render, staticRenderFns } from "./company-list-page.vue?vue&type=template&id=13696aa4&"
import script from "./company-list-page.vue?vue&type=script&lang=ts&"
export * from "./company-list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports